import { render, staticRenderFns } from "./tdPart.vue?vue&type=template&id=2b2ef1e7&"
import script from "./tdPart.vue?vue&type=script&lang=js&"
export * from "./tdPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports